__turbopack_context__.v({
  "root": "VEG4lW_root",
});
